module.exports = __webpack_public_path__ + "static/flags/VC-7e09ca6eb37ee9edaa690fda13d05544.gif";